import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";

import { VerificationCodeComponent } from "./verification-code.component";

@NgModule({
	declarations: [VerificationCodeComponent],
	imports: [CommonModule, ReactiveFormsModule],
	exports: [VerificationCodeComponent],
})
export class VerificationCodeModule {}
